import React from 'react';
import { motion } from 'framer-motion';
import { businessOutcomes, whoItsFor } from '../data/features';
import { Reveal, Stagger, staggerItem } from './MotionPrimitives';

const colors = ['text-yellow-400', 'text-violet-400', 'text-emerald-400', 'text-orange-400', 'text-sky-400', 'text-pink-400'];

export default function WhyZuntly() {
  return (
    <section id="why" className="section-pad bg-black">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="pill-light">Why Zuntly</span>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Built for how <span className="grad-text">shops actually run</span>
          </h2>
          <p className="mt-4 text-mute">
            Real results on the shop floor, not marketing fluff.
          </p>
        </Reveal>

        <Stagger className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {businessOutcomes.map((item, i) => (
            <motion.div key={item.title} variants={staggerItem} className="il-card">
              <p className={`text-xs font-semibold uppercase tracking-wider ${colors[i % colors.length]}`}>
                Outcome
              </p>
              <h3 className="mt-3 text-lg font-bold text-white">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mute">{item.desc}</p>
            </motion.div>
          ))}
        </Stagger>

        <Reveal className="mt-16 text-center">
          <h3 className="text-xl font-bold text-white">Built for teams like yours</h3>
          <p className="mt-2 text-sm text-faint">For retail and distribution teams across India</p>
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {whoItsFor.map((name, i) => (
              <div
                key={name}
                className="rounded-2xl border border-white/10 bg-card px-3 py-5 text-center"
              >
                <p className={`text-sm font-semibold ${colors[i % colors.length]}`}>{name}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-12 overflow-hidden rounded-2xl border border-white/10 bg-card px-6 py-6 sm:flex sm:items-center sm:justify-between sm:px-8">
          <div className="flex items-start gap-4">
            <span className="text-2xl">🏆</span>
            <div>
              <p className="font-semibold text-white">Ready to run award-winning retail ops together?</p>
              <p className="mt-1 text-sm text-mute">
                Let&apos;s map Zuntly to your shops, warehouse, and delivery team.
              </p>
            </div>
          </div>
          <a href="#contact" className="mt-4 inline-flex rounded-full bg-grad-cta px-5 py-2.5 text-sm font-semibold text-white sm:mt-0">
            Start Project
          </a>
        </Reveal>
      </div>
    </section>
  );
}
